export default "__VITE_ASSET__fa3b74de__"